/**
 * Calcula la edad entre una fecha de nacimiento y la fecha actual.
 * @param {string|object} fechaNacimientoInput - Fecha en formato 'YYYY-MM-DD' o un objeto Dayjs/Date.
 * @returns {string} La edad en formato "X Años Y Meses Z Días" o cadena vacía si no hay fecha.
 */
export const calcularEdadDetallada = (fechaNacimientoInput) => {
  if (!fechaNacimientoInput) {
    return '';
  }

  let fechaNacimiento;

  // Si viene de Material UI / Day.js (tiene el método .toDate o .isValid)
  if (fechaNacimientoInput && typeof fechaNacimientoInput.toDate === 'function') {
    fechaNacimiento = fechaNacimientoInput.toDate();
  } 
  // Si ya es un objeto Date nativo
  else if (fechaNacimientoInput instanceof Date) {
    fechaNacimiento = fechaNacimientoInput;
  } 
  // Si es un String ('YYYY-MM-DD')
  else if (typeof fechaNacimientoInput === 'string') {
    fechaNacimiento = new Date(fechaNacimientoInput + 'T00:00:00');
  } 
  else {
    return '';
  }

  // Si por alguna razón la fecha no es válida, evitar romper la app
  if (isNaN(fechaNacimiento.getTime())) {
    return '';
  }

  const hoy = new Date();
  
  let anos = hoy.getFullYear() - fechaNacimiento.getFullYear();
  let meses = hoy.getMonth() - fechaNacimiento.getMonth();
  let dias = hoy.getDate() - fechaNacimiento.getDate();

  if (dias < 0) {
    meses--;
    const diasMesAnterior = new Date(hoy.getFullYear(), hoy.getMonth(), 0).getDate();
    dias += diasMesAnterior;
  }

  if (meses < 0) {
    anos--;
    meses += 12;
  }
  
  if (anos < 0) {
    return "Fecha futura"; 
  }

  const partes = [];
  if (anos > 0) {
    partes.push(`${anos} ${anos === 1 ? 'Año' : 'Años'}`);
  }
  if (meses > 0) {
    partes.push(`${meses} ${meses === 1 ? 'Mes' : 'Meses'}`);
  }
  if (dias > 0 || partes.length === 0) {
     if (partes.length === 0 && dias === 0) {
        return "Hoy";
     }
    partes.push(`${dias} ${dias === 1 ? 'Día' : 'Días'}`);
  }
  
  return partes.join(' ');
};